<template>
    <div class="jh-container">
        <div class="jh-ui-header">
            <h1>SMS 발송이력</h1>
            <div class="is-right">
            </div>
        </div>
        <div class="jh-search-form">
            <table>
                <colgroup>
                    <col width="55px">
                    <col width="250px">
                    <col width="70px">
                    <col width="100px">
                    <col width="70px">
                    <col width="100px">
                    <col width="100px">
                    <col>
                </colgroup>
                <tr>
                    <th><label>발송일자</label></th>
                    <td>
                        <div class="jh-cols">                        
                            <v-menu v-model="menuStartDate" :close-on-content-click="false" transition="scale-transition" min-width="auto" offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="from" v-bind="attrs" v-on="on" class="jh-form" clearable append-icon="jh-icon-calendar is-blue" @keyup.enter="menuStartDate = false"
                                    maxlength="10" @input="fromOnInput" @click:clear="dates[0] = ''" oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/^(\d{4})(\d{2})(\d{2})$/, '$1-$2-$3');"></v-text-field>
                                </template>
                                <v-date-picker class="jh-calendar" v-model="dates[0]" @input="menuStartDate = false" no-title locale="ko-KR" :max="dates[1]" :day-format="mixin_getDate" @change="startDate"></v-date-picker>
                            </v-menu>
                            <span class="jh-unit">~</span>                       
                            <v-menu v-model="menuEndDate" :close-on-content-click="false" transition="scale-transition" min-width="auto" offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="to" v-bind="attrs" v-on="on" class="jh-form" clearable append-icon="jh-icon-calendar is-blue" @keyup.enter="menuEndDate = false"
                                    maxlength="10" @input="toOnInput" @click:clear="dates[1] = ''" oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/^(\d{4})(\d{2})(\d{2})$/, '$1-$2-$3');"></v-text-field>
                                </template>
                                <v-date-picker class="jh-calendar" v-model="dates[1]" @input="menuEndDate = false" no-title locale="ko-KR" :min="dates[0]" :day-format="mixin_getDate" @change="endDate"></v-date-picker>
                            </v-menu>
                        </div>
                    </td>
                    <th><label>고객번호</label></th>
                    <td>
                        <input type="text" class="jh-form" :disabled="CHK_BL == true" v-model="searchValue.CUST_NO" @keypress.enter="search">
                    </td>
                    <th><label>수신번호</label></th>
                    <td>
                        <input type="text" class="jh-form" v-model="searchValue.RECP_CELLPHN_NO" oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, '$1-$2-$3');"  @keypress.enter="search">
                    </td>
                    <td class="is-jh-20">
                        <v-checkbox class="jh-check" v-model="CHK_BL" label="미인증" @click="refreshCustNo"></v-checkbox>
                    </td>                    
                    <td class="has-search">
                        <v-btn class="jh-btn is-search" @click="search">조회</v-btn>
                    </td>
                </tr>
            </table>
        </div>
        <div class="jh-cols">
            <div class="jh-form-wrap is-pt-10">
                <div class="jh-ui-header">
                    <h3>SMS 발송 리스트</h3>
                    <div class="is-right">
                    </div>
                </div>
                <data-tables
                    ref="dataTable"
                    :data-table-options="dataTableOptions"
                    @click:row="onClickRow"
                    :paginationOptions="paginationOptions"
                    v-model="selectedRows"
                />
            </div>
            <div class="jh-form-wrap is-pt-10 is-col-fix" style="width: 40%;">
                <div class="jh-ui-header">
                    <h3>SMS 발송 상세정보</h3>
                    <div class="is-right">  
                    </div>
                </div>
                <table class="jh-tbl-detail">
                    <colgroup>
                        <col width="80px">
                        <col>
                        <col width="80px">
                        <col>
                    </colgroup>
                    <tbody>
                        <tr>
                            <th><label>고객번호</label></th>
                            <td>
                                <span class="is-value">{{ smsHistoryDetail.RECP_CUST_NO }}</span>
                            </td>
                            <th><label>고객명</label></th>
                            <td>
                                <span class="is-value">{{ smsHistoryDetail.RECP_NM }}</span>
                            </td>
                        </tr>
                        <tr>
                            <th><label>수신번호</label></th>
                            <td>
                                <span class="is-value">{{ smsHistoryDetail.RECP_CELLPHN_NO }}</span>
                            </td>
                            <th><label>발송번호</label></th>
                            <td>
                                <span class="is-value">{{ smsHistoryDetail.RTN_PHN_NO }}</span>
                            </td>
                        </tr>
                        <!-- <tr>
                            <th><label>발송일시</label></th>
                            <td>
                                <span class="is-value">{{ (smsHistoryDetail.REQ_DT || "") + " " + (smsHistoryDetail.REQ_TM || "") }}</span>
                            </td>
                            <th><label>발송자</label></th>
                            <td>
                                <span class="is-value">{{ smsHistoryDetail.SEND_NM }}</span>
                            </td>
                        </tr> -->
                        <tr>
                            <th><label>제목</label></th>
                            <td colspan="3">
                                <span class="is-value">{{ smsHistoryDetail.TITLE }}</span>
                            </td>
                        </tr>
                        <tr>
                            <th><label>내용</label></th>
                            <td colspan="3" class="is-p-0">
                                <v-textarea class="jh-form is-trns" style="height:528px" readonly v-model="smsHistoryDetail.CONTENT" />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import { mixin } from "@/mixin/mixin.js";
import dataTables from "@/components/DataTables";

export default {
    name: "MENU_E030102", //name은 'MENU_' + 파일명 조합
    mixins: [mixin],
    props: {},
    components: {
        dataTables
    },
    data() {
        return {
            CHK_BL: false,
            menuStartDate: false,
            menuEndDate: false,
            from: moment().format("YYYY-MM-DD"),
            to: moment().format("YYYY-MM-DD"),
            dates: [
                moment().format("YYYY-MM-DD"),
                moment().format("YYYY-MM-DD")
            ],

            searchValue: {
                CUST_NO: null,
                RECP_CELLPHN_NO: null
            },

            dataTableOptions: {
                fixedHeader: true,
                headers: [
                    { text: "순번", value: "ROWNUM", align: "center", width: "40px" },
                    { text: "발송일자", value: "REQ_DT", align: "center", width: "90px" },
                    { text: "발송시간", value: "REQ_TM",  align: "center", width: "70px" },
                    { text: "제목", value: "TITLE", },
                    { text: "수신번호", value: "RECP_CELLPHN_NO",  align: "center", width: "110px" },
                    { text: "발송직원", value: "SEND_NM",  align: "center", width: "120px" },
                    { text: "발송결과", value: "RSLT",  align: "center", width: "80px" },
                    // { text: "구분", value: "DIVS",  align: "center", width: "70px" },
                ],
                height: "620px",
                hideDefaultFooter: true,
                itemKey: "ID",
                itemsPerPage: 50,
                noDataText: "조회된 결과가 없습니다.",
                page: 1,
                singleSelect: true,

                load: this.getList
            },
            paginationOptions: {
                totalVisible: 10
            },

            requestData: {
                headers: {
                    SERVICE: "message.channel.sms",
                    TYPE: "BIZ_SERVICE",
                },
                sendData: {},
            },

            selectedKey: null,
            selectedRows: [],

            smsHistoryDetail: {
                ID: null,
                REQ_DT: null,
                REQ_TM: null,
                RECP_CUST_NO: null,
                RECP_NM: null,
                TITLE: null,
                RECP_CELLPHN_NO: null,
                RTN_PHN_NO: null,
                SEND_NM: null,
                RSLT: null,
                DIVS: null, // 구분??????
                CONTENT: null
            }
        };
    },
    computed: {   
        dataTableInstance: function() {
            return this.$refs.dataTable;
        },
    },
    methods: {
        init: async function() {
            // 헤더 초기화 및 세팅
            this.setDataTableParams();
        },
        refreshCustNo(e) {
            this.searchValue.CUST_NO = null
        },      
        telNumFormat(e) {
            console.log("RRRRRRR" +e);
        },
        setDataTableParams: function() {
            // header 세팅
            this.requestData.headers.URL = "/api/message/sms/history/list";
            this.requestData.headers.METHOD = "list";
            this.requestData.headers.ASYNC = false;

            // sendData 세팅

            this.requestData.sendData.FROM = this.dates[0];
            this.requestData.sendData.TO = this.dates[1];
            this.requestData.sendData.CUST_NO = this.searchValue.CUST_NO;
            this.requestData.sendData.RECP_CELLPHN_NO = this.searchValue.RECP_CELLPHN_NO;
            this.requestData.sendData.CHK_BL = this.CHK_BL;
            // this.requestData.sendData.USER_ID = this.$store.getters["userStore/GE_USER_ROLE"].userId;
        },
        getList: async function(loadOptions) {
            // 페이징 정보 세팅
            this.requestData.headers.ROW_CNT = loadOptions.itemsPerPage;
            this.requestData.headers.PAGES_CNT = loadOptions.page;
            if (loadOptions.sortBy && loadOptions.sortBy.length > 0)
                this.requestData.sendData.SORT_ORDR = loadOptions.sortBy[0];
            else this.requestData.sendData.SORT_ORDR = undefined;
            if (loadOptions.sortDesc && loadOptions.sortDesc.length > 0)
                this.requestData.sendData.SORT_DRCT = loadOptions.sortDesc[0] ? "desc" : "asc";
            else this.requestData.sendData.SORT_DRCT = undefined;

            return this.common_postCall(this.requestData).then((response) => {
                if (this.mixin_isEmpty(response) || response.HEADER.ERROR_FLAG) {
                    this.common_alert(`시스템에 오류가 발생하였습니다.`, "error");
                    return false;
                }

                let header = response.HEADER;
                let data = response.DATA;
                _.each(data, (item) => {
                    item.TITLE = this.restoreXSS(item.TITLE);
                    // 화면에서는 줄바꿈 문자를 \n으로 처리하지만, 서버에서는 \r\n으로 처리하므로 서버에서 가져온 문자열의 줄바꿈 문자를 모두 변경
                    item.CONTENT = _.replace(item.CONTENT, /\r\n/gi, "\n");
                    item.CONTENT = this.restoreXSS(item.CONTENT);
                    item.REQ_TM = item.REQ_TM ? item.REQ_TM.substring(0, 8) : item.REQ_TM;
                });

                return {
                    data: data,
                    totalCount: header.TOT_COUNT,
                };
            });
        },
        search: function() {

            if(!this.checkDate()) return false;

            this.setDataTableParams();

            if (this.dataTableOptions.page > 1) this.dataTableOptions.page = 1;
            else this.dataTableInstance.loadData();
        },
        checkDate() {
            if (moment(this.dates[1]).isAfter(moment(this.dates[0]).add(3, 'months').format('YYYY-MM-DD'))) {
                this.common_alert('검색 기간은 최대 3개월까지 선택 가능합니다.');
                return false;
            } 

            return true;
        },
        fromOnInput: function() {
            // 날짜 포맷과 일치하고 입력일자에 문제가 없을 때만 datepicker에 반영
            if (/^\d{4}-\d{2}-\d{2}$/.test(this.from) && moment(this.from).isValid()) {
                // 종료일자보다 이후를 입력했으면 종료일자로 변경
                if (moment(this.from).isAfter(this.dates[1])) {
                    this.$nextTick(() => {
                        this.from = this.dates[1];
                    });
                }

                this.$nextTick(() => {
                    this.dates[0] = this.from;
                    // datepick 다시 랜더링
                    this.menuStartDate = false;
                    this.menuStartDate = true;
                });
            }
        },
        startDate(e) {
            this.from = e;
        },
        toOnInput: function() {
            // 날짜 포맷과 일치하고 입력일자에 문제가 없을 때만 datepicker에 반영
            if (/^\d{4}-\d{2}-\d{2}$/.test(this.to) && moment(this.to).isValid()) {
                // 시작일자보다 이전을 입력했으면 시작일자로 변경
                if (moment(this.to).isBefore(this.dates[0])) {
                    this.$nextTick(() => {
                        this.to = this.dates[0];
                    });
                }
                
                this.$nextTick(() => {
                    this.dates[1] = this.to;
                    // datepick 다시 랜더링
                    this.menuEndDate = false;
                    this.menuEndDate = true;
                });
            }
        },
        endDate(e) {
            this.to = e;
        },

        onClickRow: function(item, row) {
            if (this.selectedKey === item.ID) {
                row.select(false);
                row.expand(false);
                this.selectedKey = null;
                this.smsHistoryDetail = {
                    ID: null,
                    REQ_DT: null,
                    REQ_TM: null,
                    RECP_CUST_NO: null,
                    RECP_NM: null,
                    TITLE: null,
                    RECP_CELLPHN_NO: null,
                    RTN_PHN_NO: null,
                    SEND_NM: null,
                    RSLT: null,
                    DIVS: null, // 구분??????
                    CONTENT: null
                };
            }
            else {
                row.select(true);
                row.expand(true);
                this.selectedKey = item.ID;
                this.smsHistoryDetail = Object.assign(this.smsHistoryDetail, item);
            }
        },
    },
    created() {},
    mounted() {
        this.init();
    },
    watch: {}
};
</script>

<style></style>